<template>
  <div>
    <div class="fixed-image" @click="openChat">
      <img src="@/assets/images/consult-image.png" alt=""/>
    </div>
    <div class="chat-window" v-if="isChatVisible">
      <div class="chat-header" @click.stop="closeChat">
        <span class="title">在职学历-免费咨询</span>
        <span class="el-icon-close">
          <img src="@/assets/images/close.png" alt=""/>
        </span>
      </div>
      <div class="iframe-container" v-if="isChatVisible">
        <iframe class="iframe" src="https://ada.baidu.com/site/wjzik1q1/agent?imid=fe92ff77ed0a07c9f281242eecb969f0" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isChatVisible: false
    };
  },
  methods: {
    /** 关闭聊天窗口 */
    closeChat() {
      if (this.isConfirming) return; // 防止多次调用
      this.isConfirming = true;
      if (confirm("是否确定关闭？")) {
        console.log("用户选择了确定");
        this.isChatVisible = false;
      } else {
        console.log("用户选择了取消");
      }
      this.isConfirming = false; // 重置标志位
    },
    /** 打开聊天窗口 */
    openChat() {
      this.isChatVisible = true;
    },
  }
};
</script>

<style scoped lang="less">
.fixed-image{
  position: fixed;
  bottom: 250px;
  right: 10px;
  z-index: 10000;
  img{
    width: 120px;
  }
}
.iframe{
  width:100%;
  height: calc(100vh - 500px); /* 修改为动态高度 */
}
.chat-window {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 10000;
  width: 100%;
  border-radius: 8px;
  background: #FFFFFF;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.chat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background:rgb(229, 120, 11);
  color: white;
}

.title {
  font-size: 30px;
  font-weight: bold;
}

.el-icon-close {
  cursor: pointer;
  //margin-left: auto;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// components/ChatWindow.vue